// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("bck.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Caveat&family=Permanent+Marker&family=Poppins&family=Roboto&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
    box-sizing: border-box;
}

* {
    margin: 0;
}

body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
}

img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
}

input, button, textarea, select {
    font: inherit;
}

p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
}

#root, #__next {
    isolation: isolate;
}


body {
    font-family: 'Caveat', cursive;
}

::selection {
    background-color: #FEE715;
    color: #101820;
}

::-webkit-scrollbar {
    width: 10px; 
    height: 10px;
}

::-webkit-scrollbar-thumb {
    background: #FEE715; 
}
  
::-webkit-scrollbar-thumb:hover {
    background: #c8b612; 
}
  
::-webkit-scrollbar-track {
    background: #555;
}

* {
    scrollbar-color:  #FEE715 #555; 
}

#content {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 130vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.header {
    width: 100%;
    height: 10%;
    padding: 10px;
    background-color: #101820;
    color: white;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-size: 33px;
}

.header-cafe {
    font-size: 45px;
    font-family: 'Permanent Marker', cursive;
    color: #FEE715;
}

.header-element:not(.current-card):hover {
    color: gainsboro;
}

.header-element:hover {
    cursor: pointer;
}

.current-card {
    color: #FEE715;
}

.card {
    background-color: #101820;
    height: 65%;
    width: 35%;
    border-radius: 15px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border: none;
}

.card-header {
    font-size: 40px;
    text-align: center;
    font-family: 'Permanent Marker', cursive;
    color: #FEE715;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
}

.header-sticker {
    height: 70px;
    width: 70px;
}

.card-content {
    height: 80%;
    color: white;
    font-size: 20px;
    text-align: justify;
    width: 100%;
}

.para {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    line-height: 33px;
    font-family: 'Poppins', cursive;
}

.menu-para {
    justify-content: space-evenly;
}

.menu-item {
    font-size: 19px;
    font-weight: bold;
}

.card-sticker-div {
    height: 0%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 95%;
}

.card-sticker {
    height: 70px;
    width: 70px;
}

.photo-credit {
    background-color: rgba(16, 24, 32, .7);
    color: white;
    font-size: 22px;
    width: 25%;
    border-radius: 5px;
    text-align: center;
}

a {
    text-decoration: none;
    color: gainsboro;
}

a:hover {
    color: #FEE715;
}

.footer {
    width: 100%;
    height: 10%;
    background-color: #101820;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 35px;
}

.fa-github {
    font-size: 35px;
    cursor: pointer;
    transition: 0.3s ease-in-out;
    color: white;
}

.fa-github:hover {
    transform: scale(1.2);
    color: #FEE715;
}

/*Media Queries*/
@media screen and (min-width: 1800px) {
    .header-cafe {
        font-size: 55px;
    }

    .header-element {
        font-size: 40px;
    }

    .card-header {
        font-size: 45px;
    }

    .para {
        font-size: 30px;
        line-height: 40px;
    }

    .menu-item {
        font-size: 25px;
    }

    .photo-credit {
        font-size: 28px;
        width: 20%;
    }

    .footer {
        font-size: 40px;
    }

    .fa-github {
        font-size: 40px;
    }
}

@media screen and (max-width: 1150px) {
    .card {
        width: 45%;
    }

    .photo-credit {
        width: 30%;
    }
}

@media screen and (max-width: 900px) {
    .card {
        width: 60%;
    }

    .photo-credit {
        width: 35%;
    }
}

@media screen and (max-width: 800px) {
    .card {
        width: 75%;
    }

    .photo-credit {
        width: 50%;
    }

    .header-cafe {
        font-size: 30px;
    }

    .header-element {
        font-size: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mDAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Caveat&family=Permanent+Marker&family=Poppins&family=Roboto&display=swap');\r\n\r\n*, *::before, *::after {\r\n    box-sizing: border-box;\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n}\r\n\r\nbody {\r\n    line-height: 1.5;\r\n    -webkit-font-smoothing: antialiased;\r\n}\r\n\r\nimg, picture, video, canvas, svg {\r\n    display: block;\r\n    max-width: 100%;\r\n}\r\n\r\ninput, button, textarea, select {\r\n    font: inherit;\r\n}\r\n\r\np, h1, h2, h3, h4, h5, h6 {\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n#root, #__next {\r\n    isolation: isolate;\r\n}\r\n\r\n\r\nbody {\r\n    font-family: 'Caveat', cursive;\r\n}\r\n\r\n::selection {\r\n    background-color: #FEE715;\r\n    color: #101820;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 10px; \r\n    height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: #FEE715; \r\n}\r\n  \r\n::-webkit-scrollbar-thumb:hover {\r\n    background: #c8b612; \r\n}\r\n  \r\n::-webkit-scrollbar-track {\r\n    background: #555;\r\n}\r\n\r\n* {\r\n    scrollbar-color:  #FEE715 #555; \r\n}\r\n\r\n#content {\r\n    background: url(bck.jpg);\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    height: 130vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.header {\r\n    width: 100%;\r\n    height: 10%;\r\n    padding: 10px;\r\n    background-color: #101820;\r\n    color: white;\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n    font-size: 33px;\r\n}\r\n\r\n.header-cafe {\r\n    font-size: 45px;\r\n    font-family: 'Permanent Marker', cursive;\r\n    color: #FEE715;\r\n}\r\n\r\n.header-element:not(.current-card):hover {\r\n    color: gainsboro;\r\n}\r\n\r\n.header-element:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.current-card {\r\n    color: #FEE715;\r\n}\r\n\r\n.card {\r\n    background-color: #101820;\r\n    height: 65%;\r\n    width: 35%;\r\n    border-radius: 15px;\r\n    padding: 30px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border: none;\r\n}\r\n\r\n.card-header {\r\n    font-size: 40px;\r\n    text-align: center;\r\n    font-family: 'Permanent Marker', cursive;\r\n    color: #FEE715;\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n    width: 100%;\r\n}\r\n\r\n.header-sticker {\r\n    height: 70px;\r\n    width: 70px;\r\n}\r\n\r\n.card-content {\r\n    height: 80%;\r\n    color: white;\r\n    font-size: 20px;\r\n    text-align: justify;\r\n    width: 100%;\r\n}\r\n\r\n.para {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    height: 100%;\r\n    line-height: 33px;\r\n    font-family: 'Poppins', cursive;\r\n}\r\n\r\n.menu-para {\r\n    justify-content: space-evenly;\r\n}\r\n\r\n.menu-item {\r\n    font-size: 19px;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-sticker-div {\r\n    height: 0%;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: flex-end;\r\n    width: 95%;\r\n}\r\n\r\n.card-sticker {\r\n    height: 70px;\r\n    width: 70px;\r\n}\r\n\r\n.photo-credit {\r\n    background-color: rgba(16, 24, 32, .7);\r\n    color: white;\r\n    font-size: 22px;\r\n    width: 25%;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    color: gainsboro;\r\n}\r\n\r\na:hover {\r\n    color: #FEE715;\r\n}\r\n\r\n.footer {\r\n    width: 100%;\r\n    height: 10%;\r\n    background-color: #101820;\r\n    color: white;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 35px;\r\n}\r\n\r\n.fa-github {\r\n    font-size: 35px;\r\n    cursor: pointer;\r\n    transition: 0.3s ease-in-out;\r\n    color: white;\r\n}\r\n\r\n.fa-github:hover {\r\n    transform: scale(1.2);\r\n    color: #FEE715;\r\n}\r\n\r\n/*Media Queries*/\r\n@media screen and (min-width: 1800px) {\r\n    .header-cafe {\r\n        font-size: 55px;\r\n    }\r\n\r\n    .header-element {\r\n        font-size: 40px;\r\n    }\r\n\r\n    .card-header {\r\n        font-size: 45px;\r\n    }\r\n\r\n    .para {\r\n        font-size: 30px;\r\n        line-height: 40px;\r\n    }\r\n\r\n    .menu-item {\r\n        font-size: 25px;\r\n    }\r\n\r\n    .photo-credit {\r\n        font-size: 28px;\r\n        width: 20%;\r\n    }\r\n\r\n    .footer {\r\n        font-size: 40px;\r\n    }\r\n\r\n    .fa-github {\r\n        font-size: 40px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1150px) {\r\n    .card {\r\n        width: 45%;\r\n    }\r\n\r\n    .photo-credit {\r\n        width: 30%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n    .card {\r\n        width: 60%;\r\n    }\r\n\r\n    .photo-credit {\r\n        width: 35%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n    .card {\r\n        width: 75%;\r\n    }\r\n\r\n    .photo-credit {\r\n        width: 50%;\r\n    }\r\n\r\n    .header-cafe {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .header-element {\r\n        font-size: 28px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
